
// src/lib/config.ts

/**
 * This module centralizes the access to all server-side environment variables.
 * These variables are injected securely by Firebase App Hosting from Google Secret Manager
 * or sourced from a local .env file for development.
 */

// Stripe Configuration
// These are server-side keys only.
export const STRIPE_SECRET_API_KEY = process.env.STRIPE_SECRET_API_KEY;
export const STRIPE_WEBHOOK_SECRET = process.env.STRIPE_WEBHOOK_SECRET;

// Nodemailer (for support emails)
export const NODEMAILER_TO = process.env.NODEMAILER_TO;

// Google AI (Gemini)
export const GEMINI_API_KEY = process.env.GEMINI_API_KEY;

// Recaptcha Site Key (Public) - While public, it's used in server-side logic in this app.
// If needed client-side, it should be read directly via process.env.NEXT_PUBLIC_... in the component.
export const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
